import { isEqual } from "lodash-es";

import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { ResourceFieldName } from "@app/util/fieldModel/ResourceFieldModel";
import { isSimpleCondition } from "@app/util/viewModel/assert";

import ResourceContentType from "../enum/ResourceContentType";

import ResourceContentTypeToFilterTypes from "./ResourceContentTypeToFilterTypes";

const getResourceContentTypeFilter = (type: ResourceContentType): FilterModel => {
  return type === ResourceContentType.LINK
    ? { [ResourceFieldName.URL]: { operator: FilterOperator.NOT_EQUAL, value: null } }
    : {
        [ResourceFieldName.TYPE]: {
          operator: FilterOperator.IN_ANY,
          value: ResourceContentTypeToFilterTypes[type],
        },
      };
};

export const getResourceContentTypeFromFilter = (
  filter: FilterModel
): ResourceContentType | undefined => {
  const condition = filter[ResourceFieldName.TYPE];

  const urlCondition = filter[ResourceFieldName.URL];
  if (urlCondition) {
    return ResourceContentType.LINK;
  }

  if (!condition || !isSimpleCondition(condition)) {
    return undefined;
  }

  if (urlCondition) {
    return ResourceContentType.LINK;
  }

  if (condition.operator === FilterOperator.IN_ANY) {
    const entry = Object.entries(ResourceContentTypeToFilterTypes).find(([, values]) =>
      isEqual(values, condition.value)
    )?.[0];
    return entry as ResourceContentType | undefined;
  }

  return undefined;
};

export default getResourceContentTypeFilter;
